export default {"src":"/_next/static/media/shareLIBlue.7a780525.svg","height":32,"width":32};